
/* soupmail javascript file */

$cached = {};

$cached.initialise = function() {
	$cached.contacts.init();
	$cached.folders.init();
	$cached.tags.init();
	$cached.searchdata.init();
	$cached.JSONdata.init();
};

$cached.contacts = {
	
	init : function() {
		this._items = {};
		this._changeHandler = function() { };
	},
	
	isEmpty : function() {
		
		return ((jQuery.objectSize(this._items) == 0) ? true : false);
		
	},
	
	// this function gets all contacts matching the supplied $method's - e.g. get all FROM addresses, or all FROM and TO addresses, etc.
	getAll : function($method) {
		
		if (!$method) {
			$method = ['from', 'to', 'cc'];
		}
		
		$matchingItems = [];
		
		jQuery.each(this._items, function($key, $item) {
			if (($item.method == '*') || (jQuery.inArray($item.method, $method) >= 0)) {
				$matchingItems.push($item);
			}
		});
		
		return $matchingItems;
		
	},
	
	sort_by_name_alphabetically : function(a, b) {
		if (!a.name || !b.name) {
			if (a.email.toLowerCase().replace("'", "") < b.email.toLowerCase().replace("'", "")) return -1;
			if (a.email.toLowerCase().replace("'", "") > b.email.toLowerCase().replace("'", "")) return 1;
			return 0;
		} else {
			if (a.name.toLowerCase().replace("'", "") < b.name.toLowerCase().replace("'", "")) return -1;
			if (a.name.toLowerCase().replace("'", "") > b.name.toLowerCase().replace("'", "")) return 1;
			return 0;
		}
	},
	
	// this function adds a contact to the cache
	add : function($emails, $method, $preventChange) {
		
		if ($emails) {
			
			if ($emails.email) {
				$cached.contacts.addObj($emails, $preventChange);
			} else if (typeof($emails) == 'string') {
				$cached.contacts.addObj({email:$emails}, $preventChange);
			} else {
				jQuery.each($emails, function($key, $email) {
					$cached.contacts.addObj($email, $preventChange);
				});
			}
			
			if (!$preventChange) {
				this.change();
			}
			
		}
		
	},
	
	addObj : function($person, $preventChange) {
		if (!$person.email) { return; }
		if (!$person.display_name) { $person.display_name = $person.email; }
		this._items[$person.email] = {name: $person.display_name, email: $person.email, method: '*'};
	},
	
	// make sure you call this function after doing a whole bunch of add() operations, with $preventChange set to true
	change : function() {
		
		this._changeHandler();
		
	},
	
	// call this function when you want to add an event handler, for when the cached contacts changes...
	onchange : function($func) {
		
		this._changeHandler = $func;
		
	}
	
};

$cached.folders = {
	
	init : function() {
		this._isLoaded = false;
		this._isCurrentlyLoading = false;
		this._items = {};
		this._changeHandler = function() { };
	},
	
	isEmpty : function() {
		return ((jQuery.objectSize(this._items) == 0) ? true : false);
	},
	
	// whenever as a PUT or POST on folders.json has occurred, on any screen, always call this function!
	dataHasChanged : function() {
		this._isLoaded = false;
		this._items = {};
	},
	
	// used on the main page
	dataHasLoaded : function() {
		if ($cached.folders._isCurrentlyLoadingSpecificItem) { return false; }
		return this._isLoaded;
	},
	
	// load data from API
	load : function() {
		
		// optimisation: do not reload if data exists.  You must instead inform dataHasChanged() above first, and then call this function, if you need new/updated data to load.
		if (this._isLoaded || this._isCurrentlyLoading) { return true; }
		
		// get all folders that we possibly can
		this._isCurrentlyLoading = true;
		$models.folders.getList({max_results: 250}, function($data) {
			if ($data.folders && ($data.folders != null) && ($data.folders.length > 0)) {
				jQuery.each($data.folders, function($key, $folder) {
					$cached.folders.add($folder, true);
				});
				//$cached.folders.change();
			}
			$cached.folders._isLoaded = true;
			$cached.folders._isCurrentlyLoading = false;
		});
		
	},
	
	loadSpecificItem : function($folderid) {
		
		if (this.getItem($folderid) || (this._isCurrentlyLoadingSpecificItem == $folderid)) { return true; }
		
		this._isCurrentlyLoadingSpecificItem = $folderid;
		$models.folders.getItem($folderid, function($folder) {
			$cached.folders.add($folder, true);
			$cached.folders._isCurrentlyLoadingSpecificItem = false;
		});
		
	},
	
	// this function gets all cached folders
	getAll : function() {
		return this._items;
	},
	
	// this function gets a specific cached folder
	getItem : function($folderid) {
		
		if (!this._items[$folderid]) {
			return false;
		}
		
		return this._items[$folderid];
		
	},
	
	// this function adds a folder to the cache
	add : function($folder, $preventChange) {
		
		$folder.id = $soupmail.string.dashesToUnderscores($soupmail.string.stringUrlSafe($folder.id));
		
		if ($folder && $folder.id && !this._items[$folder.id]) {
			this._items[$folder.id] = $folder;
			if (!$preventChange) {
				this.change();
			}
		}
		
	},
	
	// make sure you call this function after doing a whole bunch of add() operations, with $preventChange set to true
	change : function() {
		this._changeHandler();
	},
	
	// call this function when you want to add an event handler, for when the cached folders changes...
	onchange : function($func) {
		this._changeHandler = $func;
	}
	
};

$cached.tags = {
	
	init : function() {
		this._isLoaded = false;
		this._isCurrentlyLoading = false;
		this._items = {};
		this._changeHandler = function() { };
	},
	
	isEmpty : function() {
		return ((jQuery.objectSize(this._items) == 0) ? true : false);
	},
	
	// whenever as a PUT or POST on emails.json has occurred, on any screen, always call this function!
	dataHasChanged : function() {
		this._isLoaded = false;
		this._items = {};
	},
	
	// used on the main page
	dataHasLoaded : function() {
		return this._isLoaded;
	},
	
	// load data from API
	load : function() {
		
		// optimisation: do not reload if data exists.  You must instead inform dataHasChanged() above first, and then call this function, if you need new/updated data to load.
		if (this._isLoaded || this._isCurrentlyLoading) { return true; }
		
		// get all tags that we possibly can
		this._isCurrentlyLoading = true;
		$models.tags.getList({max_results: 250}, function($data) {
			if ($data.tags && ($data.tags != null) && ($data.tags.length > 0)) {
				jQuery.each($data.tags, function($key, $tag) {
					$cached.tags.add($tag, true);
				});
				//$cached.tags.change();
			}
			$cached.tags._isLoaded = true;
			$cached.tags._isCurrentlyLoading = false;
		});
		
	},
	
	// this function gets all cached tags
	getAll : function() {
		return this._items;
	},
	
	// this function gets a tag ID number, based on a supplied $name
	getId : function($name) {
		
		// in current implementation, id == name, so lets just return the name...
		return $soupmail.string.dashesToUnderscores($soupmail.string.stringUrlSafe($name));
		
		$id = false;
		
		jQuery.each(this._items, function($key, $item) {
			if ($item.name == $name) {
				$id = $item.id;
			}
		});
		
		return $id;
		
	},
	
	// this function adds a tag to the cache
	add : function($tag, $preventChange) {
		
		// if we received null values, don't cache the tag...
		if (($tag == null) || ($tag.name == null)) {
			return false;
		}
		
		// in current implementation, id == name, so lets just store the name as the ID
		$tag.id = $soupmail.string.dashesToUnderscores($soupmail.string.stringUrlSafe($tag.name));
		
		if ($tag && $tag.id && !this._items[$tag.id]) {
			this._items[$tag.id] = $tag;
			if (!$preventChange) {
				this.change();
			}
		}
		
	},
	
	// make sure you call this function after doing a whole bunch of add() operations, with $preventChange set to true
	change : function() {
		this._changeHandler();
	},
	
	// call this function when you want to add an event handler, for when the cached tags changes...
	onchange : function($func) {
		this._changeHandler = $func;
	}
	
};

$cached.searchdata = {
	
	init : function() {
		this._isLoaded = false;
		this._isCurrentlyLoading = false;
		this._items = {};
		this._changeHandler = function() { };
	},
	
	isEmpty : function() {
		return ((jQuery.objectSize(this._items) == 0) ? true : false);
	},
	
	// whenever as a PUT or POST on folders.json has occurred, on any screen, always call this function!
	dataHasChanged : function() {
		this._isLoaded = false;
		this._items = {};
	},
	
	// used on the main page
	dataHasLoaded : function() {
		return this._isLoaded;
	},
	
	// load data from API
	load : function() {
		
		// optimisation: do not reload if data exists.  You must instead inform dataHasChanged() above first, and then call this function, if you need new/updated data to load.
		if (this._isLoaded || this._isCurrentlyLoading) { return true; }
		
		// Main page now loads its cached data from search.json - for folders, tags and contacts.  It does this by doing a search.json for " " (a space character) which is not absolutely optimal, but it's more reliable and simpler than doing multiple API requests, and it also Resolves #140
		this._isCurrentlyLoading = true;
		$models.all.getDataFromAPI('search.json', {keywords: ' ', max_results: 60}, function($data) {
			
			if ($data.folders && ($data.folders != null) && ($data.folders.length > 0)) {
				jQuery.each($data.folders, function($key, $folder) {
	//				$cached.folders.add($folder, true);
				});
			}
			if ($data.tags && ($data.tags != null) && ($data.tags.length > 0)) {
				jQuery.each($data.tags, function($key, $tag) {
					$cached.tags.add($tag, true);
				});
			}
			if ($data.tags && ($data.tags != null) && ($data.tags.length > 0)) {
				jQuery.each($data.email_addresses, function($key, $person) {
					//$cached.contacts.add($person, true);
					$cached.contacts.addObj($person, true);
				});
			}
			
			$cached.searchdata._isLoaded = true;
			$cached.searchdata._isCurrentlyLoading = false;
			
		});
		
	}
	
};

$cached.JSONdata = {
	
	init : function() {
		this._items = {};
	},
	
	dataHasChanged : function() {
		this._items = {};
	},
	
	isEmpty : function() {
		
		return ((jQuery.objectSize(this._items) == 0) ? true : false);
		
	},
	
	// this function adds some JSON data to the cache
	set : function($key, $val) {
		
		this._items[$key] = {key : $key, val : $val};
		
	},
	
	// this function gets some JSON data from the cache
	get : function($key) {
		
		$result = {};
		
		jQuery.each(this._items, function($k, $item) {
			if ($item.key == $key) {
				$result = $item.val;
			}
		});
		
		return $result;
		
	},
	
	// this function returns a boolean indicating whether the specified key exists in the cache
	exists : function($key) {
		
		$result = false;
		
		jQuery.each(this._items, function($k, $item) {
			if ($item.key == $key) {
				$result = true;
			}
		});
		
		return $result;
		
	}
	
};



// WEBPACK FOOTER //
// ./src/js/helpers/soupmail.cacheddata.js